<template>
    <div class="filters-group">
        <div class="filters-group-label">
            {{title}}
        </div>
        <div v-bind:class="{active: model_from}" class="filters-group-outer" style="width: 80px; border-radius: 4px 0px 0px 4px;">
            <input @keydown="showResultsButtonFn" v-model="model_from" type="text" placeholder="от">
        </div>
        <div v-bind:class="{active: model_to}" class="filters-group-outer" style="width: 80px; border-radius: 0px; border-right: none; border-left: none;">
            <input @keydown="showResultsButtonFn" v-model="model_to" type="text" placeholder="до">
        </div>
        <div class="filters-group-outer" style="width: 80px; border-radius: 0px 4px 4px 0px;">
            <select @change="showResultsButtonFn" v-model="multiplierModel">
                <option value="1000">тыс. руб.</option>
                <option value="1000000">млн. руб.</option>
                <option value="1000000000">млрд. руб.</option>
                <option value="1000000000000">трлн. руб.</option>
            </select>
        </div>
        <div v-if="model_from || model_to || (multiplierModel != 1000)" @click="erase" class="filters-group-erase">
            <i class="lnr lnr-cross"></i>
        </div>
    </div>
</template>

<script>
export default {
    props: ['title', 'type'],
    methods: {
        showResultsButtonFn() {
            this.$store.commit('search/updateSearchObject', { obj: 'showResultsButton', value: true })
        },
        erase() {
            this.$store.commit("search/setValueInsideFilterDataObject", {
                type: this.$props.type,
                value: '',
                object_key: 'from'
            })
            this.$store.commit("search/setValueInsideFilterDataObject", {
                type: this.$props.type,
                value: '',
                object_key: 'to'
            })
            this.$store.commit("search/setValueInsideFilterDataObject", {
                type: this.$props.type,
                value: 1000,
                object_key: 'multiplier'
            })
        }
    },
    computed: {
        model_from: {
            get(){ return this.$store.state.search.filterData[this.$props.type].from },
            set(value){
                this.$store.commit("search/setValueInsideFilterDataObject", {
                    type: this.$props.type,
                    value,
                    object_key: 'from'
                })
            }
        },
        model_to: {
            get(){ return this.$store.state.search.filterData[this.$props.type].to },
            set(value){
                this.$store.commit("search/setValueInsideFilterDataObject", {
                    type: this.$props.type,
                    value,
                    object_key: 'to'
                })
            }
        },
        multiplierModel: {
            get() { return this.$store.state.search.filterData[this.$props.type].multiplier },
            set(value) {
                this.$store.commit('search/setValueInsideFilterDataObject',{
                    type: this.$props.type,
                    value,
                    object_key: 'multiplier'
                })
            }
        }
    }
}
</script>